import { useState } from "react";

// Text input with type-ahead suggestions; Tab accepts the highlighted one.
export default function AutocompleteInput({ value, onChange, options, className = "", padX = "px-2", testId }) {
  const [focused, setFocused] = useState(false);
  const [idx, setIdx] = useState(0);
  const v = (value || "").toLowerCase();
  const matches = v ? [
    ...options.filter((o) => o.toLowerCase().startsWith(v)),
    ...options.filter((o) => !o.toLowerCase().startsWith(v) && o.toLowerCase().includes(v)),
  ].filter((o) => o.toLowerCase() !== v).slice(0, 6) : [];
  const sel = matches[Math.min(idx, matches.length - 1)];
  const ghost = sel && sel.toLowerCase().startsWith(v) ? sel.slice(value.length) : "";
  const open = focused && matches.length > 0;

  const onKeyDown = (e) => {
    if (!open) return;
    if (e.key === "Tab" && !e.shiftKey) { e.preventDefault(); onChange(sel); setIdx(0); }
    else if (e.key === "ArrowDown") { e.preventDefault(); setIdx((idx + 1) % matches.length); }
    else if (e.key === "ArrowUp") { e.preventDefault(); setIdx((idx - 1 + matches.length) % matches.length); }
    else if (e.key === "Escape") setFocused(false);
  };

  return (
    <div className="relative">
      <input data-testid={testId} className={className} value={value} autoComplete="off"
        onChange={(e) => { onChange(e.target.value); setIdx(0); setFocused(true); }}
        onFocus={() => setFocused(true)} onBlur={() => setFocused(false)} onKeyDown={onKeyDown} />
      {open && ghost && (
        <div aria-hidden className={`absolute inset-0 ${padX} flex items-center pointer-events-none whitespace-pre overflow-hidden border border-transparent`}>
          <span className="invisible">{value}</span><span className="text-[#6B7280]" data-testid={testId && `${testId}-ghost`}>{ghost}</span>
        </div>
      )}
      {open && (
        <div className="absolute left-0 top-full mt-1 z-30 min-w-full bg-[#172033] border border-[#334155] rounded-md shadow-xl py-1" data-testid={testId && `${testId}-suggestions`}>
          {matches.map((m, i) => (
            <button type="button" key={m} tabIndex={-1} data-testid={testId && `${testId}-option-${i}`}
              onMouseDown={(e) => { e.preventDefault(); onChange(m); setIdx(0); }}
              className={`w-full text-left px-3 h-10 text-sm whitespace-nowrap flex items-center justify-between gap-4 ${m === sel ? "bg-[#F59E0B]/15 text-white" : "text-[#9CA3AF] hover:bg-[#1F293D]"}`}>
              {m}{m === sel && <span className="font-mono text-[10px] text-[#F59E0B] border border-[#F59E0B]/50 px-1 rounded-sm">TAB</span>}
            </button>
          ))}
        </div>
      )}
    </div>
  );
}
